import * as React from "react";
import { Text } from "@fluentui/react-components";

/*
        When regenerating, find and replace with regex enabled, empty string as replacement and this search text:
        color:\s*(#[0-9A-Za-z]+|rgb\s*\(\d+,\s*\d+,\s*\d+\)).*?(?=;);\s*

        Afterwards, insert the following css style into the first style tag at the top:
        a {
                color: #7f85f5;
        }
*/

export const ReturnPolicy = React.memo(() => (
    <Text>
        <div dangerouslySetInnerHTML={{
            __html: `<style>
a {
	color: #7f85f5;
}

  [data-custom-class='body'], [data-custom-class='body'] * {
          background: transparent !important;
        }
[data-custom-class='title'], [data-custom-class='title'] * {
          font-family: Arial !important;
font-size: 26px !important;

        }
[data-custom-class='subtitle'], [data-custom-class='subtitle'] * {
          font-family: Arial !important;

font-size: 14px !important;
        }
[data-custom-class='heading_1'], [data-custom-class='heading_1'] * {
          font-family: Arial !important;
font-size: 19px !important;

        }
[data-custom-class='heading_2'], [data-custom-class='heading_2'] * {
          font-family: Arial !important;
font-size: 17px !important;

        }
[data-custom-class='body_text'], [data-custom-class='body_text'] * {
          
font-size: 14px !important;
font-family: Arial !important;
        }
[data-custom-class='link'], [data-custom-class='link'] * {
          
font-size: 14px !important;
font-family: Arial !important;
word-break: break-word !important;
        }
</style>

      <div data-custom-class="body">
      <div><div align="center" class="MsoNormal" style="text-align:center;line-height:115%;"><a name="_2cipo4yr3w5d"></a><div align="center" class="MsoNormal" style="text-align: left; line-height: 150%;"><strong><span style="font-size: 26px;"><span data-custom-class="title"><h1>RETURN POLICY</h1></span></span></strong></div><div align="center" class="MsoNormal" style="text-align: left; line-height: 150%;"><br></div><div align="center" class="MsoNormal" style="text-align: left; line-height: 150%;"><span style="font-size: 15px;"><span style=""><strong><span data-custom-class="subtitle">Last updated <bdt class="question">July 28, 2025</bdt></span></strong></span></span></div><div align="center" class="MsoNormal" style="text-align: left; line-height: 150%;"><span style="font-size: 15px;"><br><a name="_2cipo4yr3w5d"></a></span></div></div><div class="MsoNormal" data-custom-class="body_text" style="line-height: 1.5;"><span style="font-size: 15px; line-height: 115%; font-family: Arial; "><bdt class="block-component"></bdt></span></div><div data-custom-class="heading_1"><strong><span style="font-size: 19px;"><h2>REFUNDS</h2></span></strong></div><div data-custom-class="body_text" style="line-height: 1.5;"><span style="font-size: 15px;">All sales are final and no refund will be issued.<bdt class="block-component"></bdt></span></div><div style="line-height: 1.5;"><br></div><div data-custom-class="heading_1" style="line-height: 1.5;"><span style="font-size: 19px; "><strong><h2>QUESTIONS</h2></strong></span></div><div data-custom-class="body_text" style="line-height: 1.5;"><span style="font-size: 15px; ">If you have any questions concerning our return policy, please contact us at:</span></div><div data-custom-class="body_text" style="line-height: 1.1;"><br></div><div data-custom-class="body_text" style="line-height: 1.5;"><span style="font-size: 15px;"><bdt class="block-component"></bdt></span></span></div><div data-custom-class="body_text" style="line-height: 1.5;"><span style="font-size: 15px; "><bdt class="question">contact@ianuasoftware.com</bdt></span></div><style>
      ul {
        list-style-type: square;
      }
      ul > li > ul {
        list-style-type: circle;
      }
      ul > li > ul > li > ul {
        list-style-type: square;
      }
      ol li {
        font-family: Arial ;
      }
    </style>
      </div>
      `
        }}>
        </div>
    </Text>
));